import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left mr-2" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Back")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("a", {
    href: "javascript:void(0)",
    class: "btn default-btn outline d-inline-block",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectBackTo && _ctx.redirectBackTo(...args)))
  }, [
    _hoisted_1,
    _hoisted_2
  ]))
}